import { call, put, takeEvery } from "redux-saga/effects";
//actions
import { GetNoticeBoardSuccess, GetNoticeBoardFailure } from "../../actions/DashBoard/GetNoticeBoard";
//constant
import { GET_NOTICE_BOARD } from "../../constants/DashBoard/GetNoticeBoard";
//request type
import getRequest from "../../../util/APIHelperGet";
import { baseUrl } from "../../../util/APIBaseUrl";

export const fetchGetNoticeBoardRequest = async (actions) => {
  // eslint-disable-next-line no-return-await
  return await getRequest(
    `${baseUrl}/${actions.payload.request}?` +
      new URLSearchParams({
        limit: actions.payload.rowsPerPage,
        page: actions.payload.page,
        orderBy: JSON.stringify({
          field: actions.payload?.sortBy?.field,
          direction: actions.payload?.sortBy?.direction,
        }),
      })
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

function* fetchGetNoticeBoard(params) {
  try {
    let response = yield call(fetchGetNoticeBoardRequest, params);
    yield put(GetNoticeBoardSuccess(response));
  } catch (error) {
    console.error(error);
    yield put(GetNoticeBoardFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(GET_NOTICE_BOARD, fetchGetNoticeBoard);
}
